<dcr-segmented-progress
  [attr.low-value]="spreadData.low"
  [attr.medium-value]="spreadData.medium"
  [attr.high-value]="spreadData.high"
  class="w-full"
  data-cy="score-scatter"
></dcr-segmented-progress>
